import React, { Component } from 'react';
import Validator from 'validatorjs';
import { Row, Col, Modal, Button, Form } from 'react-bootstrap';

import { FormControl } from '../../facturotopia';
import LoadingButton from '../../facturotopia/LoadingButton';

class SupportMailForm extends Component {
  state = {};

  constructor(props) {
    super(props);

    this.state = {
      isValid: false,
      validator: new Validator({}, this.rules({})),
    };
  }

  rules(data) {
    return {
      'email': ['required', 'email'],
      'asunto': ['required', 'string', 'min:6'],
      'mensaje': ['required', 'string', 'min:6'],
    }
  }

  validate(data) {
    const validator = new Validator(data, this.rules(data));

    validator.check();

    this.setState({
      validator
    });

    return validator;
  }

  handleOnChange = (value) => {
    const data = {
      ...this.props.data,
      ...value
    }

    const validator = this.validate(data);

    this.setState({ isValid: validator.passes() });

    this.props.onChange({ ...data })
  }

  handleOnSubmit = () => {
    this.props.onSubmit();
  }

  handleOnClose = () => {
    this.props.onClose();
  }

  render() {
    const rules = this.rules();
    const { busy, isValid } = this.state;
    const { email = 'soporte@waretek.mx', data = {} } = this.props;

    return (
      <Modal backdrop="static" keyboard={ false } show={ true } centered={ true } onHide={ this.handleOnClose }>
        <Modal.Header closeButton>
          <Modal.Title>
            Solicitud de soporte
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form autoComplete="off">
            <p className="text-muted">¿Tienes algún problema o duda sobre la plataforma? Escribenos un mensaje y nos pondremos en contacto contigo tan pronto como nos sea posible, o si lo prefieres, envianos un correo a <strong>{ email }</strong></p>

            <Row className="mt-3">
              <Col>
                <FormControl type="text"
                  label="Correo"
                  name="email"
                  help="Nos pondremos en contacto a este correo que tenemos registrado, o bien, puede introducir algún otro."
                  value={ data.email }
                  rules={ rules.email }
                  onChange={ this.handleOnChange }
                />
              </Col>
            </Row>

            <Row>
              <Col>
                <FormControl type="text"
                  label="Asunto"
                  name="asunto"
                  value={ data.asunto }
                  rules={ rules.asunto }
                  onChange={ this.handleOnChange }
                />
              </Col>
            </Row>

            <Row>
              <Col>
                <FormControl as="textarea"
                  label="Mensaje"
                  name="mensaje"
                  value={ data.mensaje }
                  rules={ rules.mensaje }
                  onChange={ this.handleOnChange }
                />
              </Col>
            </Row>

            <Row className="mt-3">
              <Col>
                <Button type="button"
                  variant="secondary"
                  onClick={ this.handleOnClose }
                >
                  Cancelar
                </Button>
              </Col>

              <Col className="text-right">
                <LoadingButton type="button"
                  variant="primary"
                  disabled={ !isValid || busy }
                  loading={ busy || false }
                  onClick={ this.handleOnSubmit }
                >
                  { !!busy ? 'Enviando...' : 'Enviar'}
                </LoadingButton>
              </Col>
            </Row>
          </Form>
        </Modal.Body>
      </Modal>
    )
  }
}

export default SupportMailForm;
